import * as React from "react";
import User from "../../../_data/models/User";
import LoadingIndicatorComponent from "../../../_widgets/loadingIndicator/LoadingIndicatorComponent";
import ReduxInfiniteScroll from "redux-infinite-scroll";
import Meta from "../../../_data/models/Meta";
import UserRedirectContainer from "../../../_widgets/user/UserRedirectContainer";
import FollowContainer from "../../../_widgets/follow/FollowContainer";

interface result {
    items: any;
    meta: Meta;
    loading: boolean;
}

interface Props {
    users: result;
    profile: User;
    showFollowing: boolean;
    loadMore: (id: number, meta: Meta, showFollowing: boolean, isShop: boolean) => void;
}

const FollowListUserItemModalComponent = (props: Props) => {
    const {users, showFollowing, loadMore, profile} = props;
    const u = users.items.toArray();

    if(u.length == 0){
        return (
            <div className="tabs-panel pr-0 is-active" id="userpanel">
                <LoadingIndicatorComponent message='Loading Users...'/>
            </div>
        );
    }

    return (
        <div className="tabs-panel pr-0 is-active" id="userpanel">
            <ReduxInfiniteScroll
                loadMore={() => loadMore(profile.id, users.meta, showFollowing, false)}
                loadingMore={users.loading}
                loader={<LoadingIndicatorComponent message="Loading Users..."/>}
                holderType="ul"
                className="list-block flex-container active-scroll"
                elementIsScrollable={true}
                threshold={20}>
                {
                    u.map(user => {
                        return (
                            <li key={user.id}>
                                <div className="media-object">
                                    <UserRedirectContainer id={user.id} className="media-object-section flushed middle" element="div">
                                        <div className="img-wrapper small circle">
                                            <img src={user.profilePicture()}/>
                                        </div>
                                    </UserRedirectContainer>
                                    <UserRedirectContainer id={user.id} className="media-object-section middle" element="div">
                                        <div className="text-group follow-modal-text">
                                            <p><b>@{user.name}</b></p>
                                            <small className="subheader text-left">{user.displayProfession()}</small>
                                        </div>
                                    </UserRedirectContainer>
                                </div>
                                <FollowContainer
                                    model={user}
                                    className="primary pull-right"
                                />
                            </li>
                        );
                    })
                }
            </ReduxInfiniteScroll>
        </div>
    )
};

export default FollowListUserItemModalComponent;


// WEBPACK FOOTER //
// ./app/client/user/modal/components/FollowListUserItemModalComponent.tsx